var forgotpassword = {
    forgot: "OLVIDASTE TU CONTRASEÑA?",
    eyebrowLabel: "Soporte de contraseña",
    text1: "Ingresa tu correo para restablecer tu contraseña",
    text2: "Te enviaremos un enlace seguro para que puedas crear una nueva contraseña.",
    panelTitle: "Recupera el acceso a tu cuenta",
    panelText: "Usa el correo asociado a tu cuenta. Si existe en nuestro sistema, recibirás las instrucciones para restablecer tu contraseña.",
    email: "Email:",
    emailPlaceholder: "nombre@agencia.com",
    sendbtn: "Enviar",
    sending: "Enviando...",
    requiredEmail: "El correo es obligatorio.",
    invalidEmail: "Ingresa un correo válido.",
    genericError: "No pudimos procesar tu solicitud en este momento. Intenta nuevamente más tarde.",
    successTitle: "Revisa tu bandeja de entrada",
    successText: "Si el correo está registrado, te enviamos las instrucciones para restablecer tu contraseña.",
    successHelp: "También revisa tu carpeta de spam o correo no deseado si no ves el mensaje en los próximos minutos.",
    backToLogin: "Volver a iniciar sesión",
    resend: "Enviar otro correo",
    msg: "Se ha enviado un correo electrónico a tu bandeja de entrada"
}
module.exports = forgotpassword
